var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82366 18.3004L4.31514 20.317V40.7227H4.31445C4.31445 41.4276 4.87634 42 5.56906 42H17.4864C18.1791 42 18.741 41.4276 18.741 40.7227V33.0555C18.741 30.9091 20.3978 29.2215 22.5042 29.2215C24.6112 29.2215 26.268 30.9091 26.268 33.0555V40.7227H26.2673C26.2673 41.4276 26.8292 42 27.5219 42H39.4393C40.132 42 40.6939 41.4276 40.6939 40.7227V20.317L38.1847 18.2997V39.444H28.7765V33.0548C28.7765 29.5372 25.9574 26.6655 22.5042 26.6655C19.0509 26.6655 16.2318 29.5372 16.2318 33.0548V39.444H6.82297V18.2997L6.82366 18.3004ZM22.4696 0.000304938C22.2334 0.00521489 22.0131 0.0865797 21.8017 0.238788L0.426546 17.8529C-0.0651045 18.2653 -0.134652 19.0257 0.233054 19.5223C0.595939 20.0119 1.36784 20.0904 1.83264 19.706L22.5047 2.67903L43.1768 19.706C43.6416 20.0904 44.3921 20.009 44.7585 19.5223C45.1227 19.0397 45.0835 18.2373 44.5829 17.8529L23.2078 0.238788C22.9578 0.0662385 22.7058 -0.00530643 22.4696 0.000304938Z",
    className: "color2Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFooter);
export default __webpack_public_path__ + "static/media/home-footer.c2b282650e7d12891f75d541fea9a2db.svg";
export { ForwardRef as ReactComponent };